const getCardType = brand => {
  if (brand === 'Other' || !brand) {
    return 'fa fa-credit-card';
  }

  if (brand === 'American Express') {
    return 'fab fa-cc-amex';
  }

  let splittedBrand = brand.split(' ')[0];
  return `fab fa-cc-${splittedBrand.toLowerCase()}`;
};

const getCardLabel = payment => {
  let label = '';
  switch (payment.brand?.toLowerCase()) {
    case 'visa':
      label = 'VISA';
      break;
    case 'mastercard':
      label = 'MC';
      break;
    case 'american express':
      label = 'AMEX';
      break;
    case 'discover':
      label = 'DISC';
      break;
    default:
      label = payment.brand.toUpperCase();
      break;
  }

  return label;
};

export const updateCardInfo = payments => {
  let paymentsObject = [];

  payments.forEach(payment => {
    switch (payment.type) {
      case 'credit_card':
        payment.icon = getCardType(payment.brand);
        payment.fullName = `${getCardLabel(payment)} *${payment.last4}`;
        break;
      case 'apple_pay':
        payment.icon = 'fab fa-cc-apple-pay';
        payment.fullName = 'Apple Pay';
        break;
      case 'paypal':
        payment.icon = 'fab fa-cc-paypal';
        payment.fullName = 'PayPal';
        break;
      case 'corporate':
        payment.icon = getCardType(payment.brand);
        payment.fullName = payment.label;
        break;
      default:
        payment.icon = 'fa fa-credit-card';
        payment.fullName = `${getCardLabel(payment)} *${payment.last4}`;
        break;
    }

    paymentsObject.push(payment);
  });

  return paymentsObject;
};
